import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import {
  BasePageMetaResolver,
  PageLinkService,
  PageRobotsMeta,
  Product,
  ProductPageMetaResolver,
  ProductService,
  RoutingService,
  TranslationService,
} from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';

declare module '@spartacus/core' {
  export interface Product {
    technicalDesc?: string;
  }
}

export interface GGProduct extends Product {
  mainCategoryName: string;
  modelMark: string;
  availabilityStatus: string;
}

@Injectable()
export class CustomProductPageMetaResolver extends ProductPageMetaResolver {
  protected currentProductService = inject(CurrentProductService);
  // protected override routingService = inject(RoutingService);
  // protected override productService = inject(ProductService);
  // protected override translation = inject(TranslationService);
  // protected override basePageMetaResolver = inject(BasePageMetaResolver);
  // protected pageLinkService = inject(PageLinkService);

  constructor() {
    super(
      inject(RoutingService),
      inject(ProductService),
      inject(TranslationService),
      inject(BasePageMetaResolver),
      inject(PageLinkService)
    );
  }

  ggProduct$: Observable<any> = this.currentProductService.getProduct();

  override resolveTitle(): Observable<string> {
    return this.ggProduct$.pipe(
      switchMap((product: GGProduct) => {
        let title = product.mainCategoryName
          ? product.mainCategoryName + ' - '
          : product.summary
            ? product.summary + ' - '
            : '';
        title += product.modelMark ? product.modelMark + ' - ' : product.name ? product.name + ' - ' : '';
        title += 'Hisense';
        return this.translation.translate('pageMetaResolver.product.title', {
          title: title,
        });
      })
    );
  }

  override resolveRobots(): Observable<PageRobotsMeta[]> {
    return this.ggProduct$.pipe(
      switchMap((product: GGProduct | null) => {
        if (product?.availabilityStatus !== 'approved') {
          return of([PageRobotsMeta.NOINDEX, PageRobotsMeta.NOFOLLOW]);
        }
        return super.resolveRobots();
      })
    );
  }

  override resolveDescription(): Observable<string> {
    return this.ggProduct$.pipe(
      switchMap((product: GGProduct) => {
        const title = product.mainCategoryName
          ? product.mainCategoryName + ' -'
          : product.summary
            ? product.summary + ' -'
            : '';
        const titleSecond = product.modelMark ? product.modelMark + ' -' : product.name ? product.name + ' -' : '';
        const productDescription = product.technicalDesc ? product.technicalDesc : '';
        return this.translation.translate('pageMetaResolver.product.description', {
          description: title,
          descriptionSecond: titleSecond,
          productDescription: productDescription,
        });
      })
    );
  }
}
